<template>
    <div>
        <div>
            <c-search-form :input-search-items="searchItemsInFile"
                           :rows-per-page-items="[10,20,50]"
                           :input-create-items="createItemsInFile"
                           
                           :fields="fieldsInFile"
                           :search-div="'searchDiv'"
                           :create-div="'createDiv'"
                           :displayToolbar="false"
                           key-property="requestId"
                           :search-url="searchUrlInFile"
                           form-type="intable"
                           @onDeleteFromFile="onDeleteFromFile"
                           ref="requestInFile"
            />
            <div style="text-align: right">
                <v-spacer></v-spacer>
                <v-btn @click="onCancel" width="200">
                    {{$t("lang.common.close")}}
                </v-btn>
            </div>
        </div>



    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import Validator from "../../../../public/js/validator";
    import IUpload from "../../../components/form/Upload";
    import CSearchForm from "../../../components/form/ManageForm";

    export default {
        name: "request-component",
        components: {IUpload, CSearchForm},
        props: {
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            },
        },

        data: () => ({
            files: null,
            showList: true,
            sortField: "teacherName",
            orderBy: "asc",
            headers: [
                {
                    text: "lang.common.no",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "name",
                    width: "5%"
                },
                {
                    text: "lang.request.subject",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "task",
                    width: "25%"
                },
                {
                    text: "lang.common.clear",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "studentId",
                    width: "10%"
                }
            ],
            items: [],
            search: "",
            formRequestChoose: "lang.request.formRequestChoose",
            searchItemsInFile: [],
            createItemsInFile: [],
            searchUrlInFile: "",
            fieldsInFile: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center"
                },
                {
                    value: 'subject',
                    text: 'lang.request.subject',
                    width: "15%",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:left"
                },
                {
                    type: "select",
                    items: [],
                    itemText: "name",
                    itemValue: "id",
                    name: 'customerId',
                    value: 'customerId',
                    text: 'lang.request.customerId',
                    width: "10%",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:left"
                },

                {
                    type: "upload",
                    value: 'attachIds',
                    text: 'lang.request.fileIds',
                    width: "10%",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:left"
                },
                {
                    value: 'custom_action',
                    text: "lang.request.choose",
                    icon: "delete",
                    event: "onDeleteFromFile",
                    width: "10%",
                    color: "primary"
                }
            ],
        }),
        watch: {
        },
        created() {

            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/customer", {}).then(
                data => {
                    let itemFields = this.fieldsInFile.filter(function(e) {
                        return e.name == "customerId";
                    });
                    if(itemFields != undefined && itemFields.length > 0){
                        itemFields[0].items = data.items;
                    }
                }
            )
        },
        methods: {
            viewFilesRequest(item) {
                this.files = item;
                this.searchUrlInFile= "/files/request/list/" + this.files['fileId']
            },
            cancelFilesRequest() {
                this.searchUrlInFile= "";
            },


            onSave() {
                // axios.post(process.env.VUE_APP_API_URL + "/procedure/document/saveAll", this.items).then(
                //     data => {
                //         if (data.success) {
                //             message.success(this.$t("lang.common.update_success"));
                //             this.getRequest();
                //         } else {
                //             message.error(data.description);
                //         }
                //     }
                // )

            },
            onDeleteFromFile(item) {
                item['fileId'] = "";
                item['isSendToFile'] = 0;
                axios.post(process.env.VUE_APP_API_URL + "/request/save", item).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.update_success"));
                            this.$refs.requestInFile.search();
                        } else {
                            message.error(data.description);
                        }
                    }
                )
            },
            onCancel() {
                this.$emit("cancel");
            }


        }
    };
</script>